<a [routerLink]="['/live-lesson', lesson().id]" class="schedule-item" [class.is-live]="isLive()">
  @if (isLive()) {
    <div class="live-badge">
      <span class="live-dot"></span>
      LIVE NOW
    </div>
  } @else {
    <div class="item-header">
      <div class="item-date">
        <span class="material-symbols-outlined date-icon">calendar_month</span>
        {{ lesson().starts_at | date: 'EEE d MMM · h:mma' : 'Europe/London' }}
      </div>

      @if (tierBadge()) {
        <span class="tier-badge tier-badge--{{ tierBadge() }}">
          @if (tierBadge() === 'premium') {
            <span class="material-symbols-outlined tier-icon">crown</span>
            Premium
          } @else {
            <span class="material-symbols-outlined tier-icon">school</span>
            Standard
          }
        </span>
      }
    </div>
  }

  <div class="tags">
    @if (courseTag(); as course) {
      <app-live-lesson-tag [tag]="course" [showIcon]="true" />
    }
    @for (tag of topicTags(); track tag.id) {
      <app-live-lesson-tag [tag]="tag" />
    }
  </div>

  <span class="item-title">
    {{ lesson().title }}
  </span>

  @if (lesson().description) {
    <p #descriptionEl class="item-description" [class.expanded]="showFullDescription()">
      {{ lesson().description }}
    </p>
    @if (isDescriptionTruncated()) {
      <button type="button" class="read-more" (click)="toggleDescription($event)">
        {{ showFullDescription() ? 'Show Less' : 'Read More' }}
      </button>
    }
  }
</a>
